import React from "react";
import { Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import { followUser, unfollowUser } from "../../actions/userActions";
import { showUserSignInModal } from "../../actions";
import PropTypes from "prop-types";
import { isLoggedInUser, selectLoggedInUserID } from "../../util/selectors";

const FollowToggleButton = props => {
  const { userId, postId, isFollowed, isAuthorized, currentRoutePath, loggedInUserID } = props;
  const buttonStyle = isFollowed ? "-following" : "-outline";
  const buttonText = isFollowed ? "Following" : "Follow";

  const action = () => {
    if (!isAuthorized) {
      sessionStorage.setItem("storeLastRoute", currentRoutePath);
      return props.showUserSignInModal("Log in to start following other users");
    }

    return isFollowed ? props.unfollowUser({ userId, postId }) : props.followUser({ userId, postId });
  };
  if (loggedInUserID !== userId) {
    return (
      <button className={`button -rounded -centered ${buttonStyle}`} onClick={action}>
        <Icon fitted name="add user" /> {buttonText}
      </button>
    );
  }
  return null;
};
FollowToggleButton.propTypes = {
  userId: PropTypes.string.isRequired,
  isFollowed: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  currentRoutePath: state.router.pathname,
  isAuthorized: isLoggedInUser(state),
  loggedInUserID: selectLoggedInUserID(state),
});

const mapDispatchToProps = dispatch => ({
  followUser: ({ userId, postId }) => dispatch(followUser({ userId, postId })),
  unfollowUser: ({ userId, postId }) => dispatch(unfollowUser({ userId, postId })),
  showUserSignInModal: message => dispatch(showUserSignInModal(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FollowToggleButton);



// WEBPACK FOOTER //
// ./src/components/FollowToggleButton/index.js